import { render } from "./NotesPanel.vue?vue&type=template&id=b4aec5e4&scoped=true"
import script from "./NotesPanel.vue?vue&type=script&lang=js"
export * from "./NotesPanel.vue?vue&type=script&lang=js"

import "./NotesPanel.vue?vue&type=style&index=0&id=b4aec5e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4aec5e4"]])

export default __exports__